import {useEffect, useState} from "react";

export const useFonts = (...fontNames) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!document || !document.fonts) {
      console.warn("Browser does not support document.fonts API");
      return;
    }

    Promise.all(fontNames.map((fontName) => document.fonts.load(`16px "${fontName}"`))).then(() => {
      setIsLoaded(true);
    });
  }, [fontNames]);

  return isLoaded;
};

export function beakLines(text, className = 'bg-pink p2') {
  let words = text.split("|");
  if (words.length === 1)
    return `<span class="${className}">${text}</span>`
  words = words.filter(element => {
    return element !== '';
  });
  text = '';
  words.forEach(word => {
    text += `<span class="${className}">${word}</span>`
  })
  return text
}
